import { render, staticRenderFns } from "./ChangkaihuaData.vue?vue&type=template&id=c447b052&scoped=true"
import script from "./ChangkaihuaData.vue?vue&type=script&lang=js"
export * from "./ChangkaihuaData.vue?vue&type=script&lang=js"
import style0 from "./ChangkaihuaData.vue?vue&type=style&index=0&id=c447b052&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447b052",
  null
  
)

export default component.exports